import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { withRouter } from "react-router-dom";
import ExplainFeaturesSvg from "./widgets/ExplainFeaturesSvg";
import BrandFeatures from "./widgets/BrandFeatures";
import StandardFeatures from "./widgets/StandardFeatures";
import BuildBrandFlow from "./widgets/BuildBrandFlow";
import SVGLoader from "./widgets/SVGLoader";
import DoeBanner from "./widgets/DoeBanner";
import { Settings } from "../settings";
import {
  loadDescFile,
  loadNomanclature,
  loadRules,
  LoadBuildModel,
  FixOptionPackages
} from "../stores/actions/compareModels";

class NomenclatureWizard extends Component {
  active_rule_stream = [];
  active_special_rule_stream = [];
  default_option_item = {};
  default_state = {
    selected_refrigerant: "R-448A",
    mesurement_system: "imperial",
    nomenclature_name: "HTS",
    show_nextbtn: true,
    show_prevbtn: false,
    modelready: false,
    overlay_banner: false,
    final_modelno: "",
    modelno: {
      Brand: "#",
      "Product Identifier": "#",
      "Condensing Unit Style": "#",
      Horsepower: "####",
      "Temp Range": "#",
      Voltage: "#",
      Revision: "#",
      "Compressor Manufacturer": "#",
      "Compressor Style": "#",
      "Option Packages": "#####"
    },
    rules: [],
    selectiondata: [],
    rule_children: [],
    submenu: [],

    activeMainMenuItem: "Brand",
    activeTitle: "",
    activeLogo: "",
    activeSubMenuItem: "",

    activeSpecialSubMenuItem: "HTS",
    activeSpecialSubMenuItem_fullname: "1/2 - 6 Horizontal Air Discharge",
    activeSpecialFilter: [0.5, 6],
    layout_col_class: "menu-panel-2"
  };
  pending_correction_model = {};
  all_model_nos = {"Condensing Unit":{
                                    Brand: "#",
                                    "Product Identifier": "#",
                                    "Condensing Unit Style": "#",
                                    Horsepower: "####",
                                    "Temp Range": "#",
                                    Voltage: "#",
                                    Revision: "#",
                                    "Compressor Manufacturer": "#",
                                    "Compressor Style": "#",
                                    "Option Packages": "#####"
                                      },
                    "Evaporator":{
                                     Brand: "#",
                                    "Product Identifier": "#",
                                    "Evaporator Style": "#",
                                    "BTU Capacity":"####",
                                    "Voltage":"#",
                                    "Application":"#",
                                    "Fins Per Inch":"#",
                                    "Defrost":"#",
                                    "Motor":"#",
                                    "Revision":"#",
                                    "Option Packages":"#####"
                                  },
                    "PRO3":{
                            "Brand":"#",
                            "Product Identifier":"#",
                            "Design Orientation" : "#",
                            "BTU Capacity":"####",
                            "Temp Range" : "#",
                            "Voltage" : "#",
                            "Application Location":"#",
                            "Defrost": "#",
                            "Evaporator Motor":"#",
                            "Crating":"#",
                            "Revision" : "#",
                            "Option Packages":"#####"
                    }
  };
  pdt_ident = {
    "PRO3":[
      {
          name: "PRO3",
          code: "PRO3",
          nomanclaturename: "PRO3",
          fullname: "Top Mount",
          display_name: (
            <React.Fragment>
             PRO3
              <br />
              Top Mount
            </React.Fragment>
          ),
          special_filter: [0,10000]
        }
    ],
    "Evaporator":[
         {
          name: "LOP",
          code: "LOP",
          nomanclaturename: "LOP",
          fullname: "Low Profile",
          display_name: (
            <React.Fragment>
             LOP
              <br />
              LOW PROFILE
            </React.Fragment>
          ),
          special_filter: [0,10000]
        },
        {
          name: "MP",
          code: "MP",
          nomanclaturename: "MP",
          fullname: "Medium Profile",
          display_name: (
            <React.Fragment>
             MP
              <br />
             Medium Profile
            </React.Fragment>
          ),
          special_filter: [0,100000]
        },
        {
          name: "LVCM",
          code: "LVCM",
          nomanclaturename: "LVCM",
          fullname: "Low Velocity Center Mount",
          display_name: (
            <React.Fragment>
             LVCM
              <br />
             Low Velocity<br/> Center Mount
            </React.Fragment>
          ),
          special_filter: [0,100000]
        },
        {
          name: "CM",
          code: "CM",
          nomanclaturename: "CM",
          fullname: "Center Mount",
          display_name: (
            <React.Fragment>
             CM
              <br />
              Center Mount
            </React.Fragment>
          ),
          special_filter: [0,100000]
        },
         {
          name: "LUC",
          code: "LUC",
          nomanclaturename: "LUC",
          fullname: "High Profile",
          display_name: (
            <React.Fragment>
             LUC
              <br />
              HIGH PROFILE
            </React.Fragment>
          ),
          special_filter: [0,100000]
        }
  ],
              "Condensing Unit":[
        {
          name: "1/2 - 6",
          code: "HTS",
          nomanclaturename: "HTS",
          fullname: "1/2 - 6 Horizontal Air Discharge",
          display_name: (
            <React.Fragment>
              ½ - 6 HP
              <br />
              horizontal
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [0.5, 6]
        },
        {
          name: "3 - 22 HP",
          code: "HCU",
          nomanclaturename: "HCU",
          fullname: "3 - 22 HP Horizontal Air Discharge",
          display_name: (
            <React.Fragment>
              3 – 22 HP
              <br />
              horizontal
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [3, 22]
        },
        {
          name: "12 - 50 HP",
          code: "VCU_DVCU",
          nomanclaturename: "VCU",
          fullname: "12 - 50 HP Vertical Air Discharge",
          display_name: (
            <React.Fragment>
              12 - 50 HP
              <br />
              vertical
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [12, 50]
        },
        {
          name: "24 - 100 HP ",
          code: "VCU_DVCU",
          nomanclaturename: "VCU",
          fullname: "24 - 100 HP Dual Compressor",
          display_name: (
            <React.Fragment>
              24 – 100 HP
              <br />
              dual vertical
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [24, 100]
        }
      ]}
  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = {
      ...this.default_state,
      default_model_options: [
        {
          name: "1/2 - 6",
          code: "HTS",
          nomanclaturename: "HTS",
          fullname: "1/2 - 6 Horizontal Air Discharge",
          display_name: (
            <React.Fragment>
              ½ - 6 HP
              <br />
              horizontal
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [0.5, 6]
        },
        {
          name: "3 - 22 HP",
          code: "HCU",
          nomanclaturename: "HCU",
          fullname: "3 - 22 HP Horizontal Air Discharge",
          display_name: (
            <React.Fragment>
              3 – 22 HP
              <br />
              horizontal
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [3, 22]
        },
        {
          name: "12 - 50 HP",
          code: "VCU_DVCU",
          nomanclaturename: "VCU",
          fullname: "12 - 50 HP Vertical Air Discharge",
          display_name: (
            <React.Fragment>
              12 - 50 HP
              <br />
              vertical
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [12, 50]
        },
        {
          name: "24 - 100 HP ",
          code: "VCU_DVCU",
          nomanclaturename: "VCU",
          fullname: "24 - 100 HP Dual Compressor",
          display_name: (
            <React.Fragment>
              24 – 100 HP
              <br />
              dual vertical
              <br />
              air-cooled
            </React.Fragment>
          ),
          special_filter: [24, 100]
        }
      ]
    };
  }

  tr = text => {
    if (this.state.nomenclature_name==="PRO3" && text === "Option Packages"){
      return false ;
    }
    let obj = {
      Brand: "Brand",
      "Product Identifier": "Product Identifier",
      "Condensing Unit Style": "Condensing Unit Style",
      Horsepower: "Equivalent HP",
      "Temp Range": "Temperature Range",
      Voltage: "Voltage",
      Revision: "Revision",
      "Compressor Manufacturer": "Compressor Manufacturer",
      "Compressor Style": "Compressor Type",
      "Option Packages": (
        <React.Fragment>
          <span className="hide_on_number-body">Factory Installed:</span>
          Preferred Option Packages <span className="cross">†</span>{" "}
        </React.Fragment>
      )
    };

    if (typeof obj[text] === "undefined") return text;
    else return obj[text];
  };
  correctModel = rules => {

    this.pending_correction_model = rules;

    axios
      .post(
        /*"https://cors-anywhere.herokuapp.com/" +*/
        Settings().REVERT_MODEL_URL,

        rules,
        {
          headers: {
            Authorization: "application/json"
          },
          timeout: 5000
        }
      )
      .then(response => {
        
        var r = response.data;
        let modelno = { ...this.state.modelno };
       
        let pdt_type = this.state.nomenclature_name;
        let capacity_name = (pdt_type=="HCU"||pdt_type=="HTS"||pdt_type=="VCU_DVCU")?"Horsepower":"BTU Capacity";       
        let r_capacity_name = (capacity_name=="BTU Capacity")?"BTU_Capacity":capacity_name;
        let extn = (capacity_name=="BTU Capacity")?modelno[capacity_name].split("_")[1]:"";

        let capcity_val = r[r_capacity_name].replace("#", "").replace("?", "");
        if (modelno[capacity_name] !== r[r_capacity_name] && capcity_val !== "") {
          // alert(r["Horsepower"]);
          if (extn=="" || extn==undefined){
            modelno[capacity_name] = r[r_capacity_name];
          }else{
            modelno[capacity_name] = r[r_capacity_name]+"_"+extn;
          }
          this.setState({ modelno });
        }
      })
      .catch(function(error) {
       
      });
    return;
  };
  changeRefrigerant = e => {
    this.setState({ selected_refrigerant: e.target.value });
  };

 

  finishbuild = state => {
   
    let final_modelno = "";
    let type = this.state.nomenclature_name;
    if (state == true) {
      if(
    type == "HCU" ||
    type == "VCU" ||
    type == "DVCU" ||
    type == "VCU_DVCU" ||
    type == "HTS"
  ){
    final_modelno =
        this.state.modelno["Brand"] +
        this.state.modelno["Product Identifier"] +
        this.state.modelno["Condensing Unit Style"] +
        this.state.modelno["Horsepower"] +
        this.state.modelno["Temp Range"] +
        this.state.modelno["Voltage"] +
        this.state.modelno["Revision"] +
        this.state.modelno["Compressor Manufacturer"] +
        this.state.modelno["Compressor Style"] +
        this.state.modelno["Option Packages"];

    }else if (
    type == "LOP" ||
    type == "CM" ||
    type == "LVCM" ||
    type == "LUC" ||
    type == "MP"
  ){
  final_modelno =
        this.state.modelno["Brand"] +
        this.state.modelno["Product Identifier"] +
        this.state.modelno["Evaporator Style"] +
        this.state.modelno["BTU Capacity"] +
        this.state.modelno["Voltage"] +
        this.state.modelno["Application"] +
        this.state.modelno["Fins Per Inch"] +
        this.state.modelno["Defrost"] +
        this.state.modelno["Motor"] +
        this.state.modelno["Revision"] +
        this.state.modelno["Option Packages"];

  }else{
    //PRO 3 model goes here
    final_modelno = 
        // this.state.modelno["Brand"] +
        this.state.modelno["Product Identifier"] +
        this.state.modelno["Design Orientation"] +
        this.state.modelno["BTU Capacity"] +
        this.state.modelno["Temp Range"] +
        this.state.modelno["Voltage"] +
        this.state.modelno["Application Location"] +
        this.state.modelno["Defrost"] +
        this.state.modelno["Evaporator Motor"] +
        this.state.modelno["Crating"] +
        this.state.modelno["Revision"];
  }
}

  this.props.loadBuildModel(final_modelno);  
  this.setState({ modelready: state, final_modelno });
  };


  selectSubmenuItem = (type, val_obj, finder_id) => {
   
    if (type==="Product Identifier"){
     
      let hold_old = this.state.modelno;
      this.state.modelno = this.all_model_nos[finder_id];
      this.state.modelno['Brand'] = hold_old['Brand'];

      this.state.default_model_options = this.pdt_ident[finder_id];
     
        if(finder_id === "Evaporator"){
          this.setState(
             { activeSpecialSubMenuItem_fullname : "Low Profile",
                          "activeSpecialFilter" : [0,100000000],
                           activeSubMenuItem : "Evaporator",
                           nomenclature_name : "LOP",
                           activeSpecialSubMenuItem : "LOP"}
            )
      }else if(finder_id === "PRO3"){
         this.setState(
             { activeSpecialSubMenuItem_fullname : "Top Mount",
                          "activeSpecialFilter" : [0,100000000],
                           activeSubMenuItem : "PRO3",
                           nomenclature_name : "PRO3",
                           activeSpecialSubMenuItem : "PRO3"}
            )
      }else if(finder_id === "Condensing Unit"){
         this.setState(
             { activeSpecialSubMenuItem_fullname : "1/2 - 6 Horizontal Air Discharge",
                           activeSubMenuItem : "Condensing Unit",
                          "activeSpecialFilter" : [0.5,6],
                           nomenclature_name : "HTS",
                           activeSpecialSubMenuItem : "HTS"}
            )
      }
      
        for (var i = 0; i < this.active_rule_stream.length; i++) {
            if (
                  this.active_rule_stream[i].t === this.shortform("Product Identifier") &&
                  this.active_rule_stream[i].v === finder_id
              ) {                  
                  this.active_special_rule_stream = this.active_rule_stream[i].c;
              }
        }

     
    }
    let newmodelNumber = { ...this.state.modelno };
    newmodelNumber[type] = val_obj.key;
    this.props.loadFullDesc(val_obj.html);
    this.setState({
      modelno: newmodelNumber,
      overlay_banner: false,
      activeSubMenuItem: finder_id,
      activeTitle: this.tr_r(val_obj.value),
      activeLogo: val_obj.image,
      active_selection_data: {
        type: type,
        val_obj: val_obj,
        finder_id: finder_id
      }
    });





  };
 tr_r = text => {
    if (text === "A") return "Revision A";
    if (text === "OEM") return "M - Series";
    else return text;
  };
  getnextItem = item => {
    
    if (item !== "Option Packages") {
      var keys = Object.keys(this.state.modelno);
      let next_Active_item;
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === item) return keys[i + 1];
      }
      this.setState({
        overlay_banner: false,
        activeTitle: "",
        activeLogo: "",
        activeSubMenuItem: "",
        activeSpecialSubMenuItem: "HTS",
        activeSpecialSubMenuItem_fullname: ""
      });
    }

    return "Option Packages";
  };
  getprevItem = item => {
    if (item !== "Brand") {
      var keys = Object.keys(this.state.modelno);
      let next_Active_item;
      for (var i = 0; i < keys.length; i++) {
        if (keys[i] === item) return keys[i - 1];
      }
    }

    return "Brand";
  };
  changeModelType = (fullname, code) => {
    // code is the type , fullname is custom name from default model options
   
    let p_id = "Condensing Unit"; 
    for (var i = 0; i < this.active_rule_stream.length; i++) {
     
      if (
        this.active_rule_stream[i].t === this.shortform("Product Identifier") &&
        this.active_rule_stream[i].v === this.state.activeSubMenuItem
      ) {
        //alert("Ui Ready");
        p_id = this.active_rule_stream[i].v;
        this.active_special_rule_stream = this.active_rule_stream[i].c;
       
      }
    }
    let sp_item = this.getSpecialMenuFromFullname(fullname,p_id);
   
    let code_2 = sp_item.code;
    let special_filter = sp_item.special_filter;
    this.setState({
      activeSpecialFilter: special_filter,
      activeSpecialSubMenuItem: code_2,
      activeSpecialSubMenuItem_fullname: fullname
    });
  };

  getSpecialMenuFromFullname = (fullname,pdt_id) => {
    let item;
      for(var i=0;i<this.state.default_model_options.length;i++){
        
        if(fullname === this.state.default_model_options[i].fullname){
          item = this.state.default_model_options[i];
        }
      }
    // if(pdt_id==="Evaporator"){
    // }
    // else if(pdt_id === "Condensing Unit"){
    //   for (var i = 0; i < this.state.default_model_options.length; i++) {
    //     if (fullname === this.state.default_model_options[i].fullname) {
    //       item = this.state.default_model_options[i];
    //     }
    //   }
    // }
    // else if(pdt_id === "PRO3"){      
    // }
    
    return item;
  };

  remove_underscore = btu => {
    let replaced_btu = (btu.indexOf("_")>-1)?btu.split("_")[0]:btu;
    return replaced_btu
  }

  btnNextClick = e => {
    e.preventDefault();
    let rules = [
      ...this.state.rules,
      {
        key: this.state.activeMainMenuItem,
        value: this.state.activeSubMenuItem
      }
    ];
  

    let next_Active_item = this.getnextItem(this.state.activeMainMenuItem);
   
    let rule_children = [...this.state.rule_children, this.active_rule_stream];
    if (next_Active_item === "Option Packages") {
      this.setState({ show_nextbtn: false });
      this.setState({ show_prevbtn: true });
      //this needs to be changed
      var part_modelno = "";
      let type = this.state.nomenclature_name;
    if(
        type == "HCU" ||
        type == "VCU" ||
        type == "DVCU" ||
        type == "VCU_DVCU" ||
        type == "HTS"
      ){
        part_modelno = this.state.modelno["Brand"] +
        this.state.modelno["Product Identifier"] +
        this.state.modelno["Condensing Unit Style"] +
        this.state.modelno["Horsepower"] +
        this.state.modelno["Temp Range"] +
        this.state.modelno["Voltage"] +
        this.state.modelno["Revision"] +
        this.state.modelno["Compressor Manufacturer"] +
        this.state.modelno["Compressor Style"];
        this.setState({selected_refrigerant: "R-448A"});
       }else if(
      type == "LOP" ||
      type == "CM" ||
      type == "LVCM" ||
      type == "LUC" ||
      type == "MP"
    ){
      part_modelno = this.state.modelno["Brand"] +
        this.state.modelno["Product Identifier"] +
        this.state.modelno["Evaporator Style"] +
        this.remove_underscore(this.state.modelno["BTU Capacity"]) +
        this.state.modelno["Voltage"] +
        this.state.modelno["Application"] +
        this.state.modelno["Fins Per Inch"] +
        this.state.modelno["Defrost"] +
        this.state.modelno["Motor"] +
        this.state.modelno["Revision"];

        if(this.state.modelno["Application"] === "Y"){
          this.setState({selected_refrigerant: "R-455A"});
        }
        else{
          this.setState({selected_refrigerant: "R-448A"});
        }

    }else{
      part_modelno = this.state.modelno["Product Identifier"] +
        this.state.modelno["Design Orientation"] +
        this.remove_underscore(this.state.modelno["BTU Capacity"]) +
        this.state.modelno["Temp Range"] +
        this.state.modelno["Voltage"] +
        this.state.modelno["Application Location"] +
        this.state.modelno["Defrost"] +
        this.state.modelno["Evaporator Motor"] +
        this.state.modelno["Crating"] +
        this.state.modelno["Revision"];
        this.setState({selected_refrigerant: "R-448A"});
    }

      this.props.fixOptionPackages(part_modelno);
    } else {
      this.setState({ show_nextbtn: true });
      this.setState({ show_prevbtn: true });
    }
   
   
    if (
      this.state.activeMainMenuItem === "Product Identifier" &&
      this.active_special_rule_stream.length == 0
    ) {
      //alert("Trigger");
     
      this.changeModelType(this.state.activeSpecialSubMenuItem_fullname, this.state.nomenclature_name );

      // this.changeModelType("1/2 - 6 Horizontal Air Discharge", "HTS");
    
    }



    if (this.state.activeMainMenuItem === "Product Identifier") {
      rules.push({ key: "List", value: this.state.activeSpecialSubMenuItem });
      rule_children.push(this.active_special_rule_stream);
    
    }
    let selectiondata = [
      ...this.state.selectiondata,
      this.state.active_selection_data
    ];
    
    //corect model no

    this.setState({
      rules,
      activeMainMenuItem: next_Active_item,
      rule_children,
      nomenclature_name: this.state.activeSpecialSubMenuItem,
      selectiondata,
      activeSubMenuItem: "",
      activeTitle: "",
      activeLogo: ""
    });

   
    if(this.state.modelno['Product Identifier'] == "C" || this.state.modelno['Product Identifier'] == "E"){
      this.correctModel(rules);
    }
  };
  btnPrevClick = e => {
    e.preventDefault();
    let rules = [...this.state.rules];
    rules.pop();
    let prev_Active_item = this.getprevItem(this.state.activeMainMenuItem);
   
    if (prev_Active_item === "Brand") {
      this.setState({ show_prevbtn: false });
      this.setState({ show_nextbtn: true }); 
    } else {
      this.setState({ show_prevbtn: true });
      this.setState({ show_nextbtn: true });
    }
    let rule_children = [...this.state.rule_children];
    rule_children.pop();

    let modelno = { ...this.state.modelno };
    if (this.state.activeMainMenuItem === "Horsepower") {
      modelno[this.state.activeMainMenuItem] = "####";
    } 
    else if(this.state.activeMainMenuItem === "BTU Capacity"){
      modelno[this.state.activeMainMenuItem] = "####";
    }
    else {
      modelno[this.state.activeMainMenuItem] = "#";
    }
    let prev_selection = this.state.selectiondata.pop();
    this.selectSubmenuItem(
      prev_selection.type,
      prev_selection.val_obj,
      prev_selection.finder_id
    );
   
    if (this.state.activeMainMenuItem === "Condensing Unit Style") {
      rules.pop();
      rule_children.pop();
    }
    if (this.state.activeMainMenuItem === "Evaporator Style") {
      rules.pop();
      rule_children.pop();
    }
    if(this.state.activeMainMenuItem === "Design Orientation"){
      rules.pop();
      rule_children.pop();
    }
    if (prev_Active_item === "Brand") {
      // this.setState({
      //   nomenclature_name: "HTS",
      //   activeSpecialFilter: [0.5, 6],
      //   activeSpecialSubMenuItem: "HTS",
      //   activeSpecialSubMenuItem_fullname: "1/2 - 6 Horizontal Air Discharge"
      // });
       

      if(this.state.activeMainMenuItem === "Product Identifier"){
          if(this.state.activeSubMenuItem === "Evaporator"){
            this.changeModelType("Low Profile", "LOP"); 
          }else if(this.state.activeSubMenuItem == "PRO3"){
            this.changeModelType("Top Mount", "PRO3"); 
          }else if(this.state.activeSubMenuItem === "Condensing Unit") {
            this.changeModelType("1/2 - 6 Horizontal Air Discharge", "HTS"); 
          }
        }
      
               
    }
   
    this.setState({
      modelno,
      rules,
      activeMainMenuItem: prev_Active_item,
      rule_children
    });
  };

  toFloatConvert = v => {
    
    v = v.replace("½", ".5");
    v = v.replace("¾", ".75");
    v = v.replace(" ", "");
    v = v.replace("hp", "");
    return parseFloat(v);
  };
  shortform = item => {
    let tmp = {
      Brand: "B",
      "Product Identifier": "P",
      List: "L",
      "Condensing Unit Style": "C",
      Horsepower: "H",
      "Temp Range": "T",
      Voltage: "V",
      Revision: "R",
      "Compressor Manufacturer": "M",
      "Compressor Style": "S",
      "Option Packages": "O",
      "BTU Capacity": "U",
      "Voltage" : "V",
      "Application":"I",
      "Fins Per Inch":"F",
      "Defrost": "D",
      "Motor":"O",
      "Evaporator Motor":"O",
      "Design Orientation":"N",
      "Application Location": "A",
      "Crating":"G",
      "Evaporator Style":"C"
    };
    return tmp[item];
  };
  decode = (type, key_string) => {
    try {
     
      let nm_list = this.props.compare.nomenclature.filter(nm_item => {
       

        if (nm_item.name === this.state.nomenclature_name) {
         
          return nm_item;
        }
      });
      

      let nm_filtered_list = nm_list[0].nomenclature.filter(nm_ => {
        if (nm_.type === type) {
          return nm_;
        }
      });
     

      let codes = nm_filtered_list[0].trans.filter(trans_item => {
        if (trans_item.value === key_string) {
          return trans_item;
        }
      });
      return codes[0];
    } catch (err) {
      
      return {
        key: "-",
        value: "-",
        html: "-",
        image: "-"
      };
    }
  };
  selectOption = item => {
    
    let newmodelNumber = { ...this.state.modelno };
    newmodelNumber["Option Packages"] = item.key;
    this.props.loadFullDesc(item.html);
    this.setState({
      modelno: newmodelNumber,
      overlay_banner: false,
      activeSubMenuItem: item.key,
      activeTitle: item.value,
      activeLogo: "",
      active_selection_data: {
        type: "Option Packages",
        val_obj: [],
        finder_id: item.key
      }
    });
  };
  loadSubmenu = () => {
    
    try {

      if (
        this.state.activeMainMenuItem === "Brand" &&
        this.props.compare.nomenclature.length > 0
      ) {
        this.active_rule_stream = this.state.rule_children[0];
        
        return this.props.compare.rules.map((path, index) => {
          if (path.v == "OEM") return;
          // if (path.v == "PRO3") return;
          let nom_ob = this.decode("Brand", path.v);
          
          if (index == 0 && this.state.activeSubMenuItem === "") {
            setTimeout(() => {
              this.selectSubmenuItem("Brand", nom_ob, path.v);
            }, 100);
          }
          if (typeof nom_ob !== "undefined") {
            return (
              <div
                key={path.t + "_" + path.v}
                onClick={() => {
                  this.selectSubmenuItem("Brand", nom_ob, path.v);
                }}
                className={
                  path.v === this.state.activeSubMenuItem
                    ? "brand-logos logo-active"
                    : "brand-logos"
                }
              >
                <SVGLoader
                  className={path.v + " " + "Brand_svg"}
                  url={nom_ob.image}
                />
                {/*<img src={nom_ob.image} alt={path.v} />*/}
              </div>
            );
          } 
        });
      } else if (this.state.activeMainMenuItem === "Option Packages") {
        let nm_list = this.props.compare.nomenclature.filter(nm_item => {
          if (nm_item.name === this.state.nomenclature_name) {
            return nm_item;
          }
        });

       // Create a deep copy of nm_list
        let nmc_list = JSON.parse(JSON.stringify(nm_list));
        let Options_list = nmc_list[0].nomenclature.filter(nm_item => {
          if (nm_item.type === "Option Packages") {
            if((this.state.modelno['Application'] === 'Y' || this.state.modelno['Application'] === 'y') && Array.isArray(nm_item?.trans)) {
              if(this.state.rules[6].value === "A2L refrigerants") {
                  nm_item.trans = nm_item.trans.filter(item => item.key.charAt(0) === 'G');
              }
              else {
                nm_item.trans = nm_item.trans.filter(item => item.key === 'B0000');
              }

            }
            else {
              nm_item.trans = nm_item.trans.filter(item => item.key.charAt(0) !== 'G');
            }


            return nm_item;
          }
        });

       

        let ui_option_elements = Options_list[0].trans.map((item, index) => {
          if (index == 0 && this.state.activeSubMenuItem === "") {
            setTimeout(
              item => {
                this.selectOption(item);
              },
              100,
              item
            );
          }
          return (
            <div
              key={item.key}
              onClick={() => {
                this.selectOption(item);
              }}
              className={
                item.key === this.state.activeSubMenuItem
                  ? "brand-logos logo-active"
                  : "brand-logos"
              }
            >
              <SVGLoader
                className={item.value.replace(/\s/g, "") + " " + "Option_svg"}
                url={item.image}
              />
            </div>
          );
        });
        ui_option_elements.push(
          <div
            key="Other_options"
            onClick={() => {
              //this.selectOption();
              // alert("Other Options");
              this.setState({
                /*activeSubMenuItem: "Other_options",*/
                overlay_banner: true
              });
            }}
            className={
              "Other_options" === this.state.activeSubMenuItem
                ? "brand-logos logo-active"
                : "brand-logos"
            }
          >
            <SVGLoader
              className={"Other_options" + " " + "Option_svg"}
              url="./preload/special/Other_options.svg"
            />
          </div>
        );
        // alert("check");
        let filtered_ui_elemets = ui_option_elements.filter(option_ui_item => {
          if (
            this.props.compare.fix_option.invalid_option_packages.indexOf(
              option_ui_item.key
            ) <= -1
          ) {
           
            return true;
          } else {
            //alert("Item removed" + option_ui_item.key);
            return false;
            //
          }

          //
        });

        return filtered_ui_elemets;
      } else {
        let last_rule = this.state.rule_children[
          this.state.rule_children.length - 1
        ];
        let last_defined_rule = this.state.rules[this.state.rules.length - 1];
       
        for (var i = 0; i < last_rule.length; i++) {
          if (
            last_rule[i].t === this.shortform(last_defined_rule.key) &&
            last_rule[i].v === last_defined_rule.value
          ) {
            this.active_rule_stream = last_rule[i].c;
            let display_rule = last_rule[i].c.filter(item => {
             
              if (item.key !== "List") return item;
            });
            let applied_rule = this.state.rules.filter(item => {
              if (item.key !== "List") return item;
            });
           
            let lastrule = applied_rule[applied_rule.length - 1];
            if (this.getnextItem(lastrule.key) === "Horsepower") {
             
              display_rule.sort((a, b) =>
                parseInt(a.m, 10) < parseInt(b.m, 10) ? -1 : 1
              );
            }

             if (this.getnextItem(lastrule.key) === "BTU Capacity") {
             
              display_rule.sort((a, b) =>
                parseInt(a.v, 10) < parseInt(b.v, 10) ? -1 : 1
              );
            }
            let itemfound = false;
            return display_rule.map((path, index) => {
              //let lastrule = applied_rule[applied_rule.length - 1];
              
              let nextItem = this.getnextItem(lastrule.key);
              
              let nom_ob = this.decode(nextItem, path.v);
            

              if (nextItem === "Horsepower") {
                if (
                  this.toFloatConvert(path.v) <
                    this.state.activeSpecialFilter[0] ||
                  this.toFloatConvert(path.v) >
                    this.state.activeSpecialFilter[1]
                ) {
                 
                  return;
                } 
                else if(nextItem === "BTU Capacity"){
                   if (
                  this.toFloatConvert(path.v) <
                    this.state.activeSpecialFilter[0] ||
                  this.toFloatConvert(path.v) >
                    this.state.activeSpecialFilter[1]
                ) {
                  
                  return;
                }
                }
                else {
                  if (
                    itemfound == false &&
                    this.state.activeSubMenuItem === ""
                  ) {
                    itemfound = true;
                    setTimeout(() => {
                      this.selectSubmenuItem(nextItem, nom_ob, path.v);
                    }, 100);
                  }
                 
                }
              }
              if (nextItem === "Product Identifier") {
               

                    if(nom_ob.value === "Condensing Unit"){
                      if (this.state.activeSpecialSubMenuItem === "HTS") {
                        nom_ob.image = "./preload/condensing/hts.svg";
                      }
                    if (this.state.activeSpecialSubMenuItem === "HCU") {
                        nom_ob.image = "./preload/condensing/hcu.svg";
                      }
                    if (this.state.activeSpecialSubMenuItem === "VCU_DVCU") {
                        nom_ob.image = "./preload/condensing/dvcu.svg";
                      }
                    }
                    
                    if(nom_ob.value === "Evaporator"){
                     if (this.state.activeSpecialSubMenuItem === "LOP") {
                        nom_ob.image = "./preload/evaporator/LOP.svg";
                      }
                      if (this.state.activeSpecialSubMenuItem === "LUC") {
                        nom_ob.image = "./preload/evaporator/LUC.svg";
                      }
                      if (this.state.activeSpecialSubMenuItem === "MP") {
                        nom_ob.image = "./preload/evaporator/MP.svg";
                      }
                      if (this.state.activeSpecialSubMenuItem === "CM") {
                        nom_ob.image = "./preload/evaporator/CM.svg";
                      }
                      if (this.state.activeSpecialSubMenuItem === "LVCM") {
                        nom_ob.image = "./preload/evaporator/LVCM.svg";
                      }

                    }


                    if (nom_ob.value === "PRO3"){
                      nom_ob.image = "./preload/pro3/PRO3.svg";
                    }
                
                    // if(this.state.activeSpecialSubMenuItem === "LOP"){
                    //   nom_ob.image = "./preload/evaporator/lop.svg";
                    // }
                 
                //alert(nom_ob.image);
                //alert("HCU");
                //alert(lastrule.key);
                //alert(nom_ob.image);
                
              }
             
              if (nextItem === "Condensing Unit Style") {
                if (
                  this.state.activeSpecialSubMenuItem_fullname ===
                    "12 - 40 HP Vertical Air Discharge" ||
                  this.state.activeSpecialSubMenuItem_fullname ===
                    "13 - 50 HP Vertical Air Discharge" ||
                  this.state.activeSpecialSubMenuItem_fullname ===
                    "12 - 50 HP Vertical Air Discharge"
                ) {
                  if (path.v === "Outdoor Dual Vertical") {
                    return;
                  }
                }
                if (
                  this.state.activeSpecialSubMenuItem_fullname ===
                    "24 - 80 HP Dual Compressor" ||
                  this.state.activeSpecialSubMenuItem_fullname ===
                    "26 - 100 HP Dual Compressor" ||
                  this.state.activeSpecialSubMenuItem_fullname ===
                    "24 - 100 HP Dual Compressor"
                ) {
                  if (path.v === "Outdoor Vertical") {
                    return;
                  }
                }
              }

             
           

              if (itemfound == false && this.state.activeSubMenuItem === "") {
                itemfound = true;
                setTimeout(() => {
                  this.selectSubmenuItem(nextItem, nom_ob, path.v);
                }, 100);
                 
              }
              return (
                <div
                  key={path.t + "_" + path.v + nom_ob.image}
                  onClick={() => {
                    this.selectSubmenuItem(nextItem, nom_ob, path.v);
                  }}
                  className={
                    path.v === this.state.activeSubMenuItem
                      ? "brand-logos logo-active"
                      : "brand-logos"
                  }
                >
                  <SVGLoader
                    className={path.v + " " + nextItem + "_svg"}
                    url={nom_ob.image}
                  />
                  {/*<img src={nom_ob.image} alt={path.v} />*/}
                </div>
              );
            });
          }
        }
      }
    } catch (err) {
     
      return <div> Nothing to show</div>;
    }
  };

  componentDidMount() {
    this.props.loadNomanclature();
    this.props.loadRules();
    const item = document.querySelector(
      ".restore-" + this.props.location.state
    );
    if (item) {
      item.scrollIntoView();
    }
  }
  resetUi() {
    this.active_rule_stream = [];
    this.active_special_rule_stream = [];
    this.default_option_item = {};
    this.setState({ ...this.default_state });
  }
  componentDidUpdate() {
    if (
      this.state.rule_children.length == 0 &&
      Object.keys(this.props.compare.rules).length > 0
    ) {
      //not an empty object
      //alert("New Rules are available");
      let rule_children = [[...this.props.compare.rules]];
      //this.setState({ rule_children });
      this.active_rule_stream = rule_children[0];
    }
  }
  fetchNomen = nomenclature_name => {
    for (
      var i = 0;
      i < this.props.compare.buildmodel.nomenclature.length;
      i++
    ) {
      if (
        this.props.compare.buildmodel.nomenclature[i].name === nomenclature_name
      ) {
        return this.props.compare.buildmodel.nomenclature[i];
      }
    }
    return null;
  };
  render() {
    let layout_col_class = "menu-panel-2";
    let option_package_mode_class = "";
    if (this.state.activeMainMenuItem === "Option Packages") {
      option_package_mode_class = "option_pack";
    }
    if (this.state.activeMainMenuItem === "Product Identifier")
      layout_col_class = "";
    let options = [...this.state.default_model_options];
    if (
      this.state.activeMainMenuItem === "Product Identifier" &&
      this.state.modelno["Brand"] === "M"
    ) {
      options = options.filter(item => {
        if (item.nomanclaturename === "HTS") {
          return true;
        } else {
          return false;
        }
      });
    }

    let notes =
      this.state.activeSpecialSubMenuItem === "HTS" ? (
        <div className="bg-gray disp-none-3col extra_small st_note">
          <div className="color-blue">NOTES</div>
          <div className="font11">*FSEC = Fixed Speed EC Motor</div>

          <div className="font12">
            <span>†</span>
            <span>Please contact the factory at </span>
            <a href="tel:+18003211881">
              <span> (800)-321-1881</span>
            </a>
            <span> for other factory installed options.</span>
          </div>
        </div>
      ) : (
        <div style={{ minHeight: "50px" }} className="bg-gray disp-none-3col">
          <p className="color-blue">NOTES</p>

          <p className="font11 " style={{ fontSize: "10px" }}>
            <span>†</span>
            <span>Please contact the factory at </span>
            <a href="tel:+18003211881">
              <span> (800)-321-1881</span>
            </a>
            <span> for other factory installed options.</span>
          </p>
        </div>
      );

    let next_prev_finish = (
        <React.Fragment>
        <a
          href="#"
          onClick={this.btnNextClick}
          style={{
            display: this.state.show_nextbtn ? "block" : "none"
          }}
          className="btn next-btn"
        >
          {"Next  "}
          <i className="fa fa-arrow-right" aria-hidden="true" />
        </a>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.finishbuild(true);
          }}
          style={{
            display:
              this.state.activeMainMenuItem === "Option Packages"
                ? "block"
                : "none"
          }}
          className="btn next-btn"
        >
          <i className="fa fa-check-circle" />
          {"  Finish Building"}
        </a>
        <a
          href="#"
          onClick={this.btnPrevClick}
          style={{
            display: this.state.show_prevbtn ? "block" : "none"
          }}
          className="btn prev-btn"
        >
          <i className="fa fa-arrow-left" aria-hidden="true" />
          {"  Prev"}
        </a>
      </React.Fragment>
    );
   if(this.state.nomenclature_name==="PRO3" && this.state.activeMainMenuItem === "Revision"){
    next_prev_finish = (
        <React.Fragment>
        <a
          href="#"
          onClick={this.btnNextClick}
          style={{
            display: "none"
          }}
          className="btn next-btn"
        >
          {"Next  "}
          <i className="fa fa-arrow-right" aria-hidden="true" />
        </a>
        <a
          href="#"
          onClick={e => {
            e.preventDefault();
            this.finishbuild(true);
          }}
          style={{
            display:"block"
          }}
          className="btn next-btn"
        >
          <i className="fa fa-check-circle" />
          {"  Finish Building"}
        </a>
        <a
          href="#"
          onClick={this.btnPrevClick}
          style={{
            display:  "block"
          }}
          className="btn prev-btn"
        >
          <i className="fa fa-arrow-left" aria-hidden="true" />
          {"  Prev"}
        </a>
      </React.Fragment>
    );
   }
    

    let doe_banner = <React.Fragment></React.Fragment>;
    if (
      typeof this.props.compare !== "undefined" &&
      typeof this.props.compare.buildmodel !== "undefied" &&
      typeof this.props.compare.buildmodel.nomenclature === "object" &&
      this.props.compare.buildmodel.status === "success"
    ) {
      let refrigerants = this.props.compare.buildmodel.refrigerents;
      let selectable_ref = refrigerants.map(item => {
        if (
          !isNaN(
            this.props.compare.buildmodel.doe.refrigerants[item]["Efficiency"][
              "AWEF"
            ][this.state.mesurement_system]
          )
        ) {
          return item;
        }
      });
      var filtered_selectable_ref = selectable_ref.filter(function(el) {
        return el != null;
      });
      //todo:check for more errors from adding type
      doe_banner = (
        <DoeBanner
          type={this.props.compare.buildmodel.type}
          selectable_ref={filtered_selectable_ref}
          modelno={this.state.final_modelno}
          selected_refrigerant={filtered_selectable_ref.includes(this.state.selected_refrigerant)? this.state.selected_refrigerant:filtered_selectable_ref[0]}
          refrigerant={refrigerants}
          onRefChange={this.changeRefrigerant}
          awef={
            this.props.compare.buildmodel.doe.refrigerants[
              filtered_selectable_ref.includes(this.state.selected_refrigerant)? this.state.selected_refrigerant:filtered_selectable_ref[0]
            ]["Efficiency"]["AWEF"][this.state.mesurement_system]
          }
        />
      );
    }

    if (this.state.modelready == true) {
      return (
        <div
          key={this.state.final_modelno}
          className={"inner_tab_element_" + 0}
        >
          <div className="Nav-area-final right">
            <div>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  window.print();
                }}
                className="btn print-btn"
              >
                <i className="fa fa-print" aria-hidden="true" />
                {"  Print"}
              </a>
            </div>
          </div>
          <div className="Nav-area-final">
            <div>
              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  this.finishbuild(false);
                }}
                className="btn back-btn"
              >
                <i className="fa fa-chevron-left " aria-hidden="true" />
                {"  Back"}
              </a>

              <a
                href="#"
                onClick={e => {
                  e.preventDefault();
                  this.resetUi();
                }}
                className="btn reset-btn"
              >
                <i className="fa fa-refresh" aria-hidden="true" />
                {"  Build a New Heatcraft Model"}
              </a>
            </div>
          </div>

          {doe_banner}
          <div className="features-finish">
            <ExplainFeaturesSvg
              type={this.state.nomenclature_name}
              modelnumber={this.state.final_modelno}
            />
          </div>

          <BrandFeatures
            type={this.state.nomenclature_name}
            modelnumber={this.state.final_modelno}
          />
          <StandardFeatures type={this.state.nomenclature_name} />
          <div>
            <div className="cross_note">
              {this.state.nomenclature_name === "HTS" ? (
                <ul className="awefnotes">
                  <li>
                    <h4>Notes</h4>
                  </li>
                  <li>
                    <span>*FSEC = Fixed Speed EC Motor</span>
                  </li>
                </ul>
              ) : (
                <ul className="awefnotes" />
              )}
            </div>
          </div>
        </div>
      );
    } else if(this.state.nomenclature_name === "PRO3"){
        return (
        <React.Fragment>
          <div
            ref={this.myRef}
            className={
              "Site " + layout_col_class + " " + option_package_mode_class
            }
          >
            <div className="sticky">
              <div className="BuildModelFlowSVG">
                <BuildBrandFlow type={this.state.nomenclature_name} modelno={this.state.modelno} />
              </div>
              <div className="top_next_prev_finish">{next_prev_finish}</div>
            </div>
            <div className="model-wrapper">
              <div className="model-numbers">
                <div className="model-heading">
                  <div className="model-mumber">Model Number</div>
                  <div className="model-brand">
                    {this.tr(this.state.activeMainMenuItem)}
                  </div>
                  <div className="model-brand model-brand-two">Product</div>
                  <div className="model-about-brand learn-label">
                    Learn More{" "}
                    <span className="hide-on-sm">
                      about {this.state.activeMainMenuItem}
                    </span>
                  </div>
                  <div className="clear" />
                  <div className="model-mumber number-body ">
                    {Object.entries(this.state.modelno).map(([key, value]) => {
                      if(this.state.nomenclature_name==="PRO3" && key === "Option Packages"){
                        return;
                      }else{
                        if(this.state.nomenclature_name==="PRO3" && key === "Brand"){
                          return;
                        }else{
                          return (
                              <div
                                key={key}
                                className={
                                  this.state.activeMainMenuItem === key
                                    ? "letter-item-wrapper brand-active"
                                    : "letter-item-wrapper"
                                }
                              >
                                {this.tr(key)}
                                <div className="clear" />
                                <div className="main-number">{value}</div>
                              </div>
                            );
                        }
                                                    
                      };

                    })}
                  </div>
                  <div className="only_in_option_pack">
                    <div>
                      {" "}
                      Pre-defined kits that represent frequently ordered options
                      or combinations of options. The preferred kits are
                      intended to make it easier for customers to configure
                      their units and may provide savings.
                      {notes}
                    </div>
                  </div>
                  <div
                    className="model-brand brand-body"
                    style={{
                      padding:
                        this.state.overlay_banner === true ? "0px" : "10px"
                    }}
                  >
                    <div
                      className="blackoverlay"
                      style={{
                        display:
                          this.state.overlay_banner === true ? "block" : "none"
                      }}
                    >
                      <div className="blackoverlayscreen"></div>
                      <div className="over-contain">
                        <i className="fa fa-exclamation-circle"></i>
                        <p>
                          Pre-defined kits that represent frequently ordered
                          options or combinations of options. The preferred kits
                          are intended to make it easier for customers to
                          configure their units and may provide savings. For
                          other options please visit the hub
                        </p>
                        <div className="mt14">
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              this.setState({ overlay_banner: false });
                            }}
                            className="btn st-btn1"
                          >
                            Close
                          </a>
                          <a
                            href="https://hub.heatcraftrpd.com/"
                            target="blank"
                            className="btn st-btn2"
                          >
                            Goto the Hub
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="brand-logos-wrapper">
                      {this.loadSubmenu()}
                    </div>
                  </div>
                  {/*<div className="overlay_popup">
                    
                  </div>*/}

                  <div className="model-brand model-brand-two brand-cont brand-body">
                    <div className="brand-logos-wrapper">
                      {options.map((item, index) => {
                        return (
                          <div
                            key={index + item.fullname + item.code}
                            onClick={() => {
                             
                              //alert("hii");
                              this.changeModelType(item.fullname, item.code);
                            }}
                            className={
                              this.state.activeSpecialSubMenuItem_fullname ===
                              item.fullname
                                ? "brand-logos logo-active"
                                : "brand-logos"
                            }
                          >
                            {item.display_name}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="model-about-brand about-body">
                    {notes}
                    <div className="model-content-area">
                      <div className="content-heading">
                        <h2>{this.state.activeTitle}</h2>
                        {/*<div className="content-logo">
                          <img src={this.state.activeLogo} alt="" />
                        </div>*/}
                      </div>
                      <div className="clear" />
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.props.compare.fulldesc
                        }}
                      />

                      <div className="clear" />
                      <div className="next_prev_finish_bottom">
                        {next_prev_finish}
                      </div>
                    </div>
                    <p className={this.state.activeMainMenuItem==="BTU Capacity"?"capacity-footer-show":"capacity-footer-hide"}>*Capacities shown are Application Capacities reflecting nominal operation at 10°F TD.  For models within the scope of the DOE AWEF (Annual Walk-in Energy Factor) standard, the Net Capacity is determined by the AHRI 1250 test method.  DOE will publish this compliance data at www.regulations.doe.gov</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }else{
      return (
        <React.Fragment>
          <div
            ref={this.myRef}
            className={
              "Site " + layout_col_class + " " + option_package_mode_class
            }
          >
            <div className="sticky">
              <div className="BuildModelFlowSVG">
                <BuildBrandFlow type={this.state.nomenclature_name} modelno={this.state.modelno} />
              </div>
              <div className="top_next_prev_finish">{next_prev_finish}</div>
            </div>
            <div className="model-wrapper">
              <div className="model-numbers">
                <div className="model-heading">
                  <div className="model-mumber">Model Number</div>
                  <div className="model-brand">
                    {this.tr(this.state.activeMainMenuItem)}
                  </div>
                  <div className="model-brand model-brand-two">Product</div>
                  <div className="model-about-brand learn-label">
                    Learn More{" "}
                    <span className="hide-on-sm">
                      about {this.state.activeMainMenuItem}
                    </span>
                  </div>
                  <div className="clear" />
                  <div className="model-mumber number-body ">
                    {Object.entries(this.state.modelno).map(([key, value]) => {
                      if(this.state.nomenclature_name==="PRO3" && key === "Option Packages"){
                        return;
                      }else{
                        if(this.state.nomenclature_name==="PRO3" && key === "Brand"){
                          return;
                        }else{
                          return (
                              <div
                                key={key}
                                className={
                                  this.state.activeMainMenuItem === key
                                    ? "letter-item-wrapper brand-active"
                                    : "letter-item-wrapper"
                                }
                              >
                                {this.tr(key)}
                                <div className="clear" />
                                <div className="main-number">{value.split("_")[0]}</div>
                              </div>
                            );
                        }
                                                    
                      };

                    })}
                  </div>
                  <div className="only_in_option_pack">
                    <div>
                      {" "}
                      Pre-defined kits that represent frequently ordered options
                      or combinations of options. The preferred kits are
                      intended to make it easier for customers to configure
                      their units and may provide savings.
                      {notes}
                    </div>
                  </div>
                  <div
                    className="model-brand brand-body"
                    style={{
                      padding:
                        this.state.overlay_banner === true ? "0px" : "10px"
                    }}
                  >
                    <div
                      className="blackoverlay"
                      style={{
                        display:
                          this.state.overlay_banner === true ? "block" : "none"
                      }}
                    >
                      <div className="blackoverlayscreen"></div>
                      <div className="over-contain">
                        <i className="fa fa-exclamation-circle"></i>
                        <p>
                          Pre-defined kits that represent frequently ordered
                          options or combinations of options. The preferred kits
                          are intended to make it easier for customers to
                          configure their units and may provide savings. For
                          other options please visit the hub
                        </p>
                        <div className="mt14">
                          <a
                            href="#"
                            onClick={e => {
                              e.preventDefault();
                              this.setState({ overlay_banner: false });
                            }}
                            className="btn st-btn1"
                          >
                            Close
                          </a>
                          <a
                            href="https://hub.heatcraftrpd.com/"
                            target="blank"
                            className="btn st-btn2"
                          >
                            Goto the Hub
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="brand-logos-wrapper">
                      {this.loadSubmenu()}
                    </div>
                  </div>
                  {/*<div className="overlay_popup">
                    
                  </div>*/}

                  <div className="model-brand model-brand-two brand-cont brand-body">
                    <div className="brand-logos-wrapper">
                      {options.map((item, index) => {
                        return (
                          <div
                            key={index + item.fullname + item.code}
                            onClick={() => {
                             
                              //alert("hii");
                              this.changeModelType(item.fullname, item.code);
                            }}
                            className={
                              this.state.activeSpecialSubMenuItem_fullname ===
                              item.fullname
                                ? "brand-logos logo-active"
                                : "brand-logos"
                            }
                          >
                            {item.display_name}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="model-about-brand about-body">
                    {notes}
                    <div className="model-content-area">
                      <div className="content-heading">
                        <h2>{this.state.activeTitle}</h2>
                        {/*<div className="content-logo">
                          <img src={this.state.activeLogo} alt="" />
                        </div>*/}
                      </div>
                      <div className="clear" />
                      <p
                        dangerouslySetInnerHTML={{
                          __html: this.props.compare.fulldesc
                        }}
                      />

                      <div className="clear" />
                      <div className="next_prev_finish_bottom">
                        {next_prev_finish}
                      </div>
                      <div className="clear" />

                    </div>
                    <p className={this.state.activeMainMenuItem==="BTU Capacity"?"capacity-footer-show":"capacity-footer-hide"}>*Capacities shown are Application Capacities reflecting nominal operation at 10°F TD.  For models within the scope of the DOE AWEF (Annual Walk-in Energy Factor) standard, the Net Capacity is determined by the AHRI 1250 test method.  DOE will publish this compliance data at www.regulations.doe.gov</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    }
      
  }
}

function mapStateToProps(state) {
 

  return state;
}
const mapDispatchToProps = dispatch => {
  return {
    loadRules: () => dispatch(loadRules()),
    loadFullDesc: filename => dispatch(loadDescFile(filename)),
    loadNomanclature: () => dispatch(loadNomanclature()),
    loadBuildModel: model_no => dispatch(LoadBuildModel(model_no)),
    fixOptionPackages: model_no => dispatch(FixOptionPackages(model_no))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(NomenclatureWizard));
